import { useMemo } from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Grid } from '@mui/system';
import { CustomCompactContainer } from 'components';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import { ValueEditor } from 'components/Spreadsheet/components';
import { useKpiActions } from 'pages/Financials/kpi/utils';
import theme from 'theme';
import { KpiTableProps } from './KpiTable.props';

const KpiTable = (props: KpiTableProps) => {
  const { kpiSheet, sharedProps, setTableData, isDisabled, ...rest } = props;
  const { workbook } = sharedProps;

  const companyKPIsExist = useMemo(() => kpiSheet.tableData?.companyKPIs?.length > 0, [kpiSheet.tableData]);
  const { onAddKPI, onDeleteKPI, onChangeDataType } = useKpiActions(kpiSheet, workbook);

  return (
    <CustomCompactContainer>
      <Grid size={{ xs: 12 }}>
        {companyKPIsExist ? (
          // @ts-expect-error: ScalarSpreadsheet is not typed
          <ScalarSpreadsheet
            {...kpiSheet}
            {...rest}
            {...sharedProps}
            sheet={kpiSheet}
            deleteRowFn={onDeleteKPI}
            allowChangeDataType
            changeRowDataTypeFn={onChangeDataType}
            editorForTitles={ValueEditor as any}
          />
        ) : (
          <h3 style={{ marginLeft: '1rem' }}>KPI Table</h3>
        )}
      </Grid>

      <Grid pl={theme.spacing(1.5)} size={{ xs: 12 }}>
        <Button color="primary" disabled={isDisabled} onClick={onAddKPI} startIcon={<AddIcon />} variant="outlined">
          ADD KPI ROW
        </Button>
      </Grid>
    </CustomCompactContainer>
  );
};

export default KpiTable;
